import iosRedio from './ios_button.vue'

function install(Vue){
    Vue.component(iosRedio.name,iosRedio)
}

export default{
    install
}